// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__1nY3-","title":"style_title__3dzz4","text":"style_text__3VNUN"};